import React from "react";
import {Col, Input} from "reactstrap";
import {ViewConfig} from "../views/ViewConfig";

const STYLE_WITH_VALUE = {borderWidth: "2px"};

export default class SearchInputBox extends React.Component {
  render() {
    let hasValue = this.props.value && this.props.value.length > 0;
    let valueColumns = hasValue ? {
      valid: true,
      style: STYLE_WITH_VALUE
    } : {};
    return <Col {...ViewConfig.SEARCH_BOX_PROPS}>
      {this.props.label && <label htmlFor={this.props.id}>{this.props.label}</label>}
      <Input
        {...this.props}
        {...valueColumns}
      />
    </Col>
  }
}
